import * as React from "react";

export interface StickyChildrenProps {
  isSticky: boolean;
  ref: (ref: HTMLElement | null) => void;
}
export type StickyChildrenFunc = (props: StickyChildrenProps) => React.ReactNode;

interface Props {
  children: StickyChildrenFunc;
}

interface State {
  isSticky: boolean;
  height?: number;
}

class Sticky extends React.Component<Props, State> {
  private targetRef: HTMLElement | null = null;
  private placeholderRef: HTMLElement | null = null;
  private placeholderObserver?: IntersectionObserver;

  constructor(props: Props) {
    super(props);

    this.state = {
      isSticky: false,
    };
  }

  public componentDidMount() {
    this.setState({
      height: this.targetRef!.getBoundingClientRect().height,
    });
    this.placeholderObserver = new IntersectionObserver(this.handleHeaderObserver, {
      root: null,
      rootMargin: "0px",
      threshold: [1],
    });
    this.placeholderObserver.observe(this.placeholderRef!);
  }

  public componentWillUnmount() {
    this.placeholderObserver!.unobserve(this.placeholderRef!);
    this.placeholderObserver!.disconnect();
  }

  public handleHeaderObserver: IntersectionObserverCallback = entries => {
    for (const entry of entries) {
      const rect = entry.boundingClientRect;
      if (rect.top < 0) {
        this.setState({ isSticky: true });
      } else {
        this.setState({ isSticky: false });
      }
    }
  };

  public setTargetRef = (ref: HTMLElement | null) => {
    this.targetRef = ref;
  };

  public setPlaceholderRef = (ref: HTMLElement | null) => {
    this.placeholderRef = ref;
  };

  public render() {
    const { children } = this.props;
    const { isSticky, height } = this.state;
    return (
      <>
        <div ref={this.setPlaceholderRef} style={{ height: isSticky && height ? `${height}px` : "" }} />
        {children({ isSticky, ref: this.setTargetRef })}
      </>
    );
  }
}

export default Sticky;



// WEBPACK FOOTER //
// ./frontend/src/common/components/Sticky.tsx